import api from '../utils/api';

const strategicReportsService = {
  // Retention / enrollment / workload / forecasting / cross-campus
  getRetention: (params = {}) => api.get('/api/strategic-reports/retention', { params }),
  getEnrollmentTrends: (params = {}) => api.get('/api/strategic-reports/enrollment-trends', { params }),
  getTeacherWorkload: (academicTermId) => api.get('/api/strategic-reports/teacher-workload', { params: { academic_term_id: academicTermId } }),
  getFeeForecast: (params = {}) => api.get('/api/strategic-reports/fee-forecast', { params }),
  getCampusComparison: (academicTermId) => api.get('/api/strategic-reports/campus-comparison', { params: { academic_term_id: academicTermId } }),

  // Attendance-risk alerting
  getAttendanceRiskSettings: () => api.get('/api/attendance-risk/settings'),
  updateAttendanceRiskSettings: (data) => api.put('/api/attendance-risk/settings', data),
  runAttendanceRiskNow: () => api.post('/api/attendance-risk/run-now'),
  getAttendanceRiskHistory: (params = {}) => api.get('/api/attendance-risk/history', { params }),

  // Custom report builder
  getFieldMap: () => api.get('/api/custom-reports/field-map'),
  runAdHocReport: (data) => api.post('/api/custom-reports/run', data),
  listDefinitions: () => api.get('/api/custom-reports/definitions'),
  createDefinition: (data) => api.post('/api/custom-reports/definitions', data),
  deleteDefinition: (id) => api.delete(`/api/custom-reports/definitions/${id}`),
  runDefinition: (id) => api.post(`/api/custom-reports/definitions/${id}/run`),

  // Generic configurable export (government/EMIS-style row-level CSV)
  getExportColumns: () => api.get('/api/custom-reports/export/columns'),
  getExportCsv: (source, columns, filters) => api.get('/api/custom-reports/export.csv', {
    params: { source, columns: columns.join(','), filters: filters ? JSON.stringify(filters) : undefined },
    raw: true,
  }),

  // Board reporting package (PDF)
  getBoardPack: (params) => api.get('/api/custom-reports/board-pack', { params, raw: true }),

  // Scheduled reports
  listScheduledReports: () => api.get('/api/custom-reports/scheduled'),
  createScheduledReport: (data) => api.post('/api/custom-reports/scheduled', data),
  updateScheduledReport: (id, data) => api.put(`/api/custom-reports/scheduled/${id}`, data),
  deleteScheduledReport: (id) => api.delete(`/api/custom-reports/scheduled/${id}`),
  runDueScheduledReports: () => api.post('/api/custom-reports/scheduled/run-due'),
  listScheduledReportRuns: (id) => api.get(`/api/custom-reports/scheduled/${id}/runs`),
};

export default strategicReportsService;
